



import Vue from 'vue';
import {Component, Prop } from 'vue-property-decorator';

/**
 * @status stable
 * @published 5.0.0
 * @changelog 5.0.0 Published with form revamp.
 */
@Component({
})
export default class JdsForm extends Vue {
}
